import Controller from "../Engine/Controller";
import Engine from "../Engine/Engine";
import cfJS from "../Engine/cfJS";

class CodeMirrorWidget extends Controller {

    constructor(dom, options) {
        super(dom, "CodeMirror");

        let that = this;

        Engine.uploadJS([
            "/web/lib/codemirror-5.48.4/lib/codemirror.js",
            "/web/lib/codemirror-5.48.4/mode/xml/xml.js",
            "/web/lib/codemirror-5.48.4/mode/javascript/javascript.js",
            "/web/lib/codemirror-5.48.4/mode/css/css.js",
            "/web/lib/codemirror-5.48.4/mode/clike/clike.js",
            "/web/lib/codemirror-5.48.4/mode/vbscript/vbscript.js",
            "/web/lib/codemirror-5.48.4/mode/smarty/smarty.js",
            "/web/lib/codemirror-5.48.4/mode/php/php.js"
        ], function () {
            that._init(options);

            if (options && options.afterInit)
                options.afterInit(that);
        });

        return this;
    }
    /*
    * init library with settings
    */
    _init(options) {
        /*let mixedMode = {
            name: "html",
            scriptTypes: [{matches: /\/x-handlebars-template|\/x-mustache/i,
                mode: null},
                {matches: /(text|application)\/(x-)?vb(a|script)/i,
                    mode: "vbscript"}]
        };*/

        let domNode = this.domNode,
            mode = options && options["mode"] ? options["mode"] : {name: "smarty", version: 3, baseMode: "text/html"};

        let cmEditor = CodeMirror.fromTextArea(domNode, {
            //mode: {name: "smarty", version: 3, baseMode: "text/html"},
            mode: mode,
            matchBrackets: true,
            height: "400px",
            lineNumbers:true,
            onChange: function (cm) {
                domNode.value = cm.getValue();
                console.log (domNode.value);
            }
        });

        cmEditor.on("change", function(instance, change) {
            domNode.value = cmEditor.getValue();
            //console.log (domNode.value);
        });

        this.cmEditor = cmEditor;
    }
    /*
    * set value to codemirror
    */
    setValue(value) {
        //console.log (this.cmEditor);
        this.cmEditor.setValue(value);
    }
}

window.CodeMirrorWidget = CodeMirrorWidget;